<div class="input-row d-flex">
  <mojo-input
    prefixIcon="search"
    mobile="true"
    class="flex-grow-1"
    [searchControl]="globalSearch"
  ></mojo-input>
  <button
    color="accent"
    class="cancel-button"
    mat-button
    (click)="closeModal()"
    type="button"
  >CANCEL</button>
</div>
<div class="results-wrapper">
  <mojo-global-search-results
    *ngIf="(globalSearchLoading$ | async) === false"
    [results]="searchResults$ | async"
    (searchPageEvent)="goToPage($event)"
    [searchedPhrase]="globalSearch.value"
  >
  </mojo-global-search-results>

  <mojo-loader *ngIf="(globalSearchLoading$ | async) !== false"></mojo-loader>
</div>
